import { useQuery } from '@tanstack/react-query';
import { useReviewPreviewPageStatus, useReviewPreviewParams } from 'screens/performanceReview/hooks/reviewPreviewHooks';
import useReviewResultParams from 'screens/performanceReview/hooks/useReviewResultParams';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getReviewProviders } from 'services/performanceReview';

const getData = async ({ employeeId, reviewId, providerType, isPreview, previewSubmissionStatus }) => {
  try {
    const res = await getReviewProviders({
      employeeId,
      reviewId,
      providerType,
      isPreview,
      previewSubmissionStatus,
    });

    return res;
  } catch (err) {
    console.error('Error fetching result data for reviewId : ', reviewId, ' error : ', err);
  }
  return null;
};

const useReviewResultSidebarData = () => {
  const { employeeId, reviewId } = useReviewResultParams();
  const { isPreview, providerType } = useReviewPreviewParams();
  const previewSubmissionStatus = useReviewPreviewPageStatus();

  return useQuery(
    [REACT_QUERY_KEYS.ReviewResultSidebar, employeeId, reviewId],
    () =>
      getData({
        employeeId,
        reviewId,
        providerType,
        isPreview,
        previewSubmissionStatus,
      }),
    { enabled: !!employeeId }
  );
};

export const useReviewResultProviderEmpInfo = ({ empId }) => {
  const { data: providers = [] } = useReviewResultSidebarData();
  const provider = providers?.find((item) => item?.employee?.id === empId);

  if (provider) {
    return {
      ...provider?.employee,
      providerType: provider?.review?.providerType,
      peerType: provider?.review?.peerType,
    };
  }

  return null;
};

export default useReviewResultSidebarData;
